import { render, staticRenderFns } from "./changePriceDialog.vue?vue&type=template&id=d67b25da&"
import script from "./changePriceDialog.vue?vue&type=script&lang=js&"
export * from "./changePriceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports